import React from "react";

import { Badge, Button, TabNavigation } from "@fronterahealth/frontera-ui-components";

import { navigationTabs, useClientProgrammingData } from "@providers/ClientProgrammingProvider";

interface GoalNavigationTabsProps {}

export const GoalNavigationTabs: React.FC<GoalNavigationTabsProps> = () => {
  const {
    setSelectedProgrammingGoalTab,
    selectedProgrammingGoalTab,
    selectedGoal,
    selectedTarget,
    isTreatmentPlanUploadEnabled,
  } = useClientProgrammingData();

  const getNumMoments = () => {
    let ret = 0;

    if (selectedGoal && !selectedTarget) {
      ret += selectedGoal.mediatargetpredictionSet?.totalCount || 0;
      selectedGoal.targets?.forEach((target) => {
        ret += target.mediatargetpredictionSet?.totalCount || 0;
      });
    } else if (selectedTarget) {
      ret += selectedTarget.mediatargetpredictionSet?.totalCount || 0;
    }

    if (ret > 99) {
      return "99+";
    }
    return ret;
  };

  const filteredTabs = isTreatmentPlanUploadEnabled
    ? navigationTabs
    : navigationTabs.filter((tab) => tab !== "Video Moments");

  return (
    <div>
      <div className={` no-scrollbar overflow-x-scroll border-gray-200`}>
        <TabNavigation
          shrink
          tabs={filteredTabs.map((tab) => ({
            current: selectedProgrammingGoalTab === tab,
            type: "component",
            name: tab,
            Component: (
              <Button
                text={
                  <div className="w-full flex font-normal flex-row justify-center gap-2">
                    {tab}
                    {tab === "Video Moments" && <Badge text={getNumMoments()} appearance="neutral" />}
                  </div>
                }
                appearance="text"
                className={`hover:text-primary ${selectedProgrammingGoalTab === tab ? "text-limestone-900" : "text-text-secondary"}`}
                onClick={() => setSelectedProgrammingGoalTab(tab)}
              />
            ),
          }))}
        />
      </div>
    </div>
  );
};
